export default __webpack_public_path__ + "static/screeny-110-gc-cabrio-6-c5ea212dd5e002a66cacae8a5374f64b.jpg";